import { LinkDto, MediaDto, ShareLink } from "./AdditionalDataTypes"

export interface StoryDto {
    KeyId: string
    Title: string
    DetailsUrl: string
    PreviewType: number
    DesktopPreview: MediaDto
    MobilePreview: MediaDto
    SliderImages: Array<MediaDto>
    SliderImagesMobile: Array<MediaDto>
    CreditName: string
    FormattedDate: string
    AuthorName: string
    AuthorLogo: MediaDto
    Location: string
    Description: string
    InnerDescription: string
    BackgroundColor: string
    MainTag: string
    Tags: Array<string>
}

export interface TourGroupDto {
    GroupName: string
    TotalItems: number
    PageSize: number
    Items: Array<TourPreviewDto>
}
export interface TourPreviewDto {
    KeyId: string
    Title: string
    DetailsUrl: string
    Duration: number
    Location: string
    Coordinates: Array<number>
    MainTag: string
    PreviewDesktop: MediaDto
    PreviewMobile: MediaDto
}
export interface PlaylistDto {
    KeyId: string
    Title: string
    DesktopPreview: MediaDto
    MobilePreview: MediaDto
    Url: string
}

export interface PlaylistsGroupDto {
    KeyId: string
    Name: string
    Playlists: Array<PlaylistDto>
}
export interface FilterPageDto<T> {
    PageTitle: string
    Filters: string
    Description: string
    PageSize: number
    TotalItems: number
    ShareLinks: ShareLink[]
    Items: Array<T>
    Tags: FilterPageTags
}
export interface FilterPagesDto {
    PlaylistsPage: FilterPageDto<PlaylistsGroupDto>
    StoriesPage: FilterPageDto<StoryDto>
    ToursPage: FilterPageDto<TourGroupDto>
    Translations: { [key: string]: string }
    LandingPageLink: string
    CreateNewStory: LinkDto
    GoogleMapKey: string
}

export interface FilterPageTags {
    LocationTags: FilterPageTag[]
    TimeTags: FilterPageTag[]
    ContentTags: FilterPageTag[]
    StorytellerTags: StorytellerTag[]
}

export interface FilterPageTag {
    Name: string
    Key: string
}

export interface StorytellerTag extends FilterPageTag {
    ImageUrl: string
}

export interface StorySearchModel {
    timeType: string
    timeTags: string[]
    yearsRange: number[]
    locationType: string
    locationTags: string[]
    locationQuery: string
    storytellerTags: string[]
    contentTags: string[]
    query: string
}

export interface HybridMapDto {
    GoogleMapKey: string
    Stories: StoryPreviewDto[]
}

export interface StoryPreviewDto {
    KeyId: string,
    Title: string,
    DetailsUrl: string,
    PreviewDesktop: MediaDto,
    PreviewMobile: MediaDto,
    Description: string,
    Coords: { lat: number, lng: number }
}

export enum STORY_CONTENT_TYPE_PROPERTIES {
    LOCATION = 'location',
    LOCATION_TAG = 'locationTag',
    TIME_TAG = 'timeTag',
    DATE = 'date',
    CONTENT_TAG = 'contentTag',
}

export enum TAG_TYPE {
    STATIC_TAG = "-1",
    CONFIRMED_TAG = "2"
}
